// extracted by mini-css-extract-plugin
export default {"container":"agb_container__1lfpw","layout":"agb_layout__DhP9S","back_btn":"agb_back_btn__18-01"};